import { render } from "./KoruUpload.vue?vue&type=template&id=775a5a56&ts=true"
import script from "./KoruUpload.vue?vue&type=script&lang=ts"
export * from "./KoruUpload.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__